import { Component, Input, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AutocompleteComponent } from 'angular-ng-autocomplete';
import { filter, take, takeUntil } from 'rxjs';
import { SaleHorse } from 'src/app/models/sales/sale-horse.model';
import { ToastService } from 'src/app/shared-new/services/toast.service';
import { SalesFacade } from 'src/app/shared-new/store/sales/sales.facade';
import { StudiesFacade } from 'src/app/shared-new/store/studies/studies.facade';
import { LookupModel } from '../../models/common/lookup.model';
import { Sale } from '../../models/sales/sales.model';
import { StudyFileUpload } from '../../models/Study/study-file.model';
import { AuthService } from '../../services/auth.service';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { StudyMimeType } from '../../shared-new/enums/study-mime-type.enum';
import { StudyService } from '../../shared-new/services/study.service';
import { EventsEmitter } from '../../shared/event-emitter/EventEmitter';

@Component({
  selector: 'upload-study-modal',
  templateUrl: './upload-study-modal.component.html',
  styleUrls: ['./upload-study-modal.component.scss'],
})
export class UploadStudyModalComponent extends BaseUnsubscribeComponent {
  @Input() saleId: number = null;
  @Input() horseId: number = null;
  @Input() studyId: number = null;
  @Input() saleHorse: SaleHorse = null;
  @Input() isAdditional: boolean = false;
  @Input() mediaCategoryId: number = null;
  @Input() fileType: StudyMimeType = null;

  selectedFiles?: File[] = [];
  fileCount = 0;
  uploadedFiles: string[] = [];
  activeUploadIndex: number = null;
  uploadFilesErrorResponse: any[] = [];
  isUploading: boolean = false;
  sales: Sale[];
  faXmark = faXmark;
  dicom = StudyMimeType.XRAY;
  scope = StudyMimeType.SCOPE_VIDEO;
  report = StudyMimeType.XRAY_REPORT;


  // sales: Sale[] = [];

  salesActiveForSubmission$ = this.salesFacade.salesActiveForSubmission$;
  salesLoaded$ = this.salesFacade.salesLoaded$;
  isHorseSelected: boolean = false;
  saleHorses$ = this.salesFacade.saleHorses$;
  saleHorsesLoaded$ = this.salesFacade.saleHorsesLoaded$;
  studyFileMimeTypesLoaded$ = this.studyFacade.studyFileMimeTypesLoaded$;
  studyFileMimeTypes$ = this.studyFacade.studyFileMimeTypes$;
  isMimeTypesLoaded: boolean = false;
  saleHorses: SaleHorse[];
  allSaleHorses: SaleHorse[];
  form: FormGroup;
  activeSaleId: number = null;
  lotOrHipText: string = '';

  @ViewChild(AutocompleteComponent, { static: false })
  autocompleteComponent: AutocompleteComponent;
  autocompletePlacholder: string = '';
  keyword = 'name';

  showDuplicateMessage = false;
  startBackgroundUploading = false;
  public isSaleFeatureEnabled: boolean;
  public dicomFileValidator: boolean = false;
  public scopeFileValidator: boolean = false;
  public xrayFileValidator: boolean = false;
  public isShowCheckbox: boolean = false;
  public mimeTypes: LookupModel[] = [];
  constructor(
    public readonly authService: AuthService,
    public modal: NgbActiveModal,
    private studyService: StudyService,
    private salesFacade: SalesFacade,
    private studyFacade: StudiesFacade,
    private toastService: ToastService,
    private readonly eventEmitter: EventsEmitter
  ) {
    super();
    this.form = new FormGroup({
      saleId: new FormControl('', [Validators.required]),
      horse: new FormControl('', [Validators.required]),
      filter: new FormControl(''),
    });
    this.isSaleFeatureEnabled =
      this.authService.GlobalMemberAccessData.isSaleFeatureEnabled;
    this.isShowCheckbox = this.isSaleFeatureEnabled;
    this.authService
      .getMemberLotOrHipText()
      .pipe(take(1))
      .subscribe((text) => {
        this.lotOrHipText = text;
        this.autocompletePlacholder = `Type ${this.lotOrHipText}, Horse name or DAM name to select...`;
      });
  }
  onUploadSaleHorseStudyChange(e: any): void {
    this.isSaleFeatureEnabled = e.checked;
    if (!e.checked) {
      this.fileType = this.dicom;
    } else {
      this.fileType = null;
    }
  }
  ngOnInit(): void {
    if (this.saleId && this.horseId) {
      this.isShowCheckbox = false;
      this.isSaleFeatureEnabled = false;
    }
    if (this.studyId > 0) {
      this.isSaleFeatureEnabled = false;
    }
    this.studyFacade.loadStudyFileMimeTypes();
    if (this.saleHorse == null) {
      this.salesFacade.loadSales();
    }
    this.attachEvents();

    if (this.saleId) {
      // We are fixing the selected sale and selected horse
      this.form.patchValue({ saleId: this.saleId });
      this.updateHorses();

      if (this.horseId) {
        if (this.saleHorse !== null) {
          this.onHorseSelected(this.saleHorse);
        } else {
          this.saleHorses$
            .pipe(
              filter((saleHorses) => !!saleHorses.length),
              takeUntil(this.unsubscribe$)
            )
            .subscribe((saleHorses) => {
              const horse = saleHorses.find(
                (horse) => horse.horseId == this.horseId
              );

              this.onHorseSelected(horse);
            });
        }
      }
    }

    this.studyFacade.activeSaleHorseStudy$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((study) => {
        this.showDuplicateMessage = !!study?.studyFiles.length && !this.saleId;
      });
  }
  private attachEvents() {
    this.salesFacade.salesActiveForSubmission$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((sales) => {
        this.sales = sales;
      });
    this.saleHorses$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((saleHorses) => {
        this.saleHorses = saleHorses;
        this.allSaleHorses = saleHorses;
      });
    this.eventEmitter.fileUploadDataSavedEvent
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((response) => {
        this.isUploading = false;
        this.selectedFiles = [];
        (
          document.getElementById('fileUploader') as unknown as HTMLInputElement
        ).value = null;
      });
    this.studyFileMimeTypes$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((response) => {
        this.mimeTypes = response;
      });
    this.studyFileMimeTypesLoaded$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((response) => {
        this.isMimeTypesLoaded = response;
      });
  }
  private hasDicomHeaders(file: File): Promise<boolean> {
    const DICOM_HEADER_PREFIX_LENGTH = 132;
    const DICOM_HEADER_OFFSET_START = 128;
    const DICOM_HEADER_SIGNATURE = [0x44, 0x49, 0x43, 0x4D]; // "DICM"

    return new Promise((resolve) => {
      const reader = new FileReader();
      const blob = file.slice(0, DICOM_HEADER_PREFIX_LENGTH);

      reader.onload = (e: ProgressEvent<FileReader>) => {
        const buffer = new Uint8Array(e.target!.result as ArrayBuffer);
        const isDicom =
          buffer.length >= DICOM_HEADER_PREFIX_LENGTH &&
          buffer[DICOM_HEADER_OFFSET_START] === DICOM_HEADER_SIGNATURE[0] &&
          buffer[DICOM_HEADER_OFFSET_START + 1] === DICOM_HEADER_SIGNATURE[1] &&
          buffer[DICOM_HEADER_OFFSET_START + 2] === DICOM_HEADER_SIGNATURE[2] &&
          buffer[DICOM_HEADER_OFFSET_START + 3] === DICOM_HEADER_SIGNATURE[3];

        resolve(isDicom);
      };

      reader.onerror = () => resolve(false);
      reader.readAsArrayBuffer(blob);
    });
  }

  private getFileExtension(fname: string): string {
    return fname.slice(((fname.lastIndexOf('.') - 1) >>> 0) + 2).toLowerCase();
  }
  async selectFiles(event: any): Promise<void> {
    let files = [...event.target.files];
    let filesWithExtension: File[] = [];
    let filesWithoutExtension: File[] = [];

    files.forEach(file => {
      const fileName = file.name;
      const lastDotIndex = fileName.lastIndexOf('.');

      if (lastDotIndex > 0 && lastDotIndex < fileName.length - 1) {
        filesWithExtension.push(file);
      } else {
        filesWithoutExtension.push(file);
      }
    });
    filesWithoutExtension = await Promise.all(
      filesWithoutExtension.map(async (file) => {
        if (await this.hasDicomHeaders(file)) {
          const renamedFile = new File([file], `${file.name}.dcm`, { type: file.type });
          return renamedFile;
        }
        return file;
      })
    );
    files = [...filesWithExtension, ...filesWithoutExtension];
    if (files.length == 0) {
      return;
    }
    if (this.fileType === this.dicom) {
      let extensions = 'dcm,dic';

      if (this.isMimeTypesLoaded) {
        const xrayMimeTypes = this.mimeTypes.filter(
          (x) => x.id === this.dicom
        )[0];
        extensions = xrayMimeTypes.altName;
      }

      const dicomFiles = files.filter((file) =>
        extensions.includes(this.getFileExtension(file.name))
      );
      if (dicomFiles.length > 0) {
        this.dicomFileValidator = false;
      } else {
        this.dicomFileValidator = true;
      }
    } else if (this.fileType === this.scope) {
      let extensions = 'mp4,mov,avi,mpeg,mkv,wmv,flv,f4v,webm';
      if (this.isMimeTypesLoaded) {
        const scopeMimeTypes = this.mimeTypes.filter(
          (x) => x.id === this.scope
        )[0];
        extensions = scopeMimeTypes.altName;
      }
      const otherFiles = files.filter(
        (file) => !extensions.includes(this.getFileExtension(file.name))
      );
      if (otherFiles.length > 0) {
        this.scopeFileValidator = true;
        return;
      } else {
        this.scopeFileValidator = false;
      }
    } else if (this.fileType === this.report) {
      let extensions = 'pdf,doc,docx';
      if (this.isMimeTypesLoaded) {
        const reportMimeTypes = this.mimeTypes.filter(
          (x) => x.id === this.report
        )[0];
        extensions = reportMimeTypes.altName;
      }
      const otherFiles = files.filter(
        (file) => !extensions.includes(this.getFileExtension(file.name))
      );
      if (otherFiles.length > 0) {
        this.xrayFileValidator = true;
        return;
      } else {
        this.xrayFileValidator = false;
      }
    }
    this.selectedFiles = [...files];

  }

  uploadFiles(): void {
    this.activeUploadIndex = 0;
    this.uploadFile();
  }

  uploadFile(): void {
    const saleId = this.form.value.saleId;
    let saleName = '';
    if (saleId) {
      saleName =
        this.sales.filter((x) => x.saleId == saleId)[0]?.saleName ?? '';
    }
    const horseId = this.form.value.horse?.horseId;
    let horseName = '';
    let lot = '';
    if (horseId) {
      const saleHorse = this.saleHorses.filter((x) => x.horseId == horseId)[0];
      if (saleHorse) {
        horseName = saleHorse.horseName;
        lot = saleHorse.lot;
      }
    }
    const files = this.selectedFiles.map((file) => {
      const upload = {
        file: file,
        horseId: horseId,
        saleId: saleId,
        horseName: horseName,
        saleName: saleName,
        studyId: this.studyId,
        isAdditional: this.isAdditional,
        mediaCategoryId: this.mediaCategoryId,
        lot: lot,
      } as StudyFileUpload;
      return upload;
    });
    this.isUploading = true;
    this.eventEmitter.emitFileStartUploadEvent(files);
    this.modal.close(files);
  }

  updateHorses(): void {
    if (this.form.value.saleId !== this.activeSaleId) {
      this.form.value.horse = null;
      this.fetchHorses(this.form.value.saleId);
    }
    this.activeSaleId = this.form.value.saleId;
  }

  fetchHorses(saleId: number): void {
    if (this.saleHorse == null) {
      this.autocompleteComponent?.clear();
      this.autocompletePlacholder =
        'Type HIP, Horse name or DAM name to select...';
      this.salesFacade.loadSaleHorses(saleId);
    }
  }

  filterHorses() {
    const query = this.form.value.filter;
    if (query) {
      this.saleHorses = this.allSaleHorses.filter((saleHorse) => {
        const hasLotNumber = saleHorse.lotNumber.toString().includes(query);
        const hasDamName = saleHorse.dam
          .toString()
          .toLowerCase()
          .includes(query.toLowerCase());
        const hasHorseName = saleHorse.horseName
          .toString()
          .toLowerCase()
          .includes(query.toLowerCase());
        return !!(hasLotNumber || hasDamName || hasHorseName);
      });
    } else {
      this.saleHorses = this.allSaleHorses;
    }
  }

  onHorseSelected(horse: SaleHorse): void {
    this.form.patchValue({ horse });
    const name = horse.horseName ? horse.horseName : horse.name;
    this.autocompletePlacholder =
      horse.lot + ' | ' + name + ' | ' + horse.dam;
    this.isHorseSelected = true;
    this.showDuplicateMessage = false;
    this.dicomFileValidator = false;
    this.scopeFileValidator = false;
    this.xrayFileValidator = false;
  }
  unSelectHorse(): void {
    this.form.value.horse = null;
    this.autocompletePlacholder =
      'Type HIP, Horse name or DAM name to select...';
    this.isHorseSelected = false;
  }
  scrollToItem(id: string): void {
    let el = document.getElementById(id);
    if (el) {
      el.scrollIntoView();
    }
  }

  

  removeSelectedFile(index: number): void {
    this.uploadFilesErrorResponse.splice(index, 1);
    this.selectedFiles.splice(index, 1);
  }
}
